import "./Modal.scss";
import Dialog from "@material-ui/core/Dialog";
import { Text, SVG } from "sunrise-ui";
import { DialogContent } from "@mui/material";
import { DialogTitle } from "@material-ui/core";

export interface SimpleDialogProps {
  open: boolean;
  onClose: (value: any) => void;
  components: any;
  title: string;
}

function SimpleDialog(props: SimpleDialogProps) {
  const { onClose, open, title, components } = props;

  return (
    <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle>
        <Text
          type="normal"
          fonts="normal"
          className="mt0 mb0 dflex_between"
          fontSize={18}
        >
          <span>{title}</span>
          <Text
            type="normal"
            fonts="normal"
            className="mt0 mb0 dflex_between pointer"
            fontSize={16}
            onTextClick={onClose}
          >
            
            <SVG type="close" />
          </Text>
        </Text>
      </DialogTitle>
      <DialogContent>{components}</DialogContent>
    </Dialog>
  );
}

const Modal = (props: any) => (
  <SimpleDialog
    open={props.open}
    onClose={props.onClose}
    components={props.children}
    title={props.title}
  />
);

export default Modal;
